import React, { useRef } from "react";

const ResizableHeader = ({ select = false, index, onResize, children }) => {
  const thRef = useRef(null);

  const handleMouseDown = (e) => {
    const startX = e.clientX;
    const startWidth = thRef.current.offsetWidth;

    const handleMouseMove = (moveEvent) => {
      const newWidth =
        startWidth + (moveEvent.clientX - startX) - (select ? 45 : 0); // 45 is width of select column
      onResize(index, Math.max(newWidth, 20)); // Minimum width
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <th
      ref={thRef}
      className={`relative font-ubuntuBold hover:bg-secondary hover:text-white hover:rounded px-4 py-2`}
    >
      {children}
      <div
        className=" active:shadow hover:shadow shadow-black active:bg-primary bg-greenGlass hover:bg-primary rounded absolute top-0 right-0 bottom-0 w-2 cursor-col-resize"
        onMouseDown={handleMouseDown}
      ></div>
    </th>
  );
};

export default ResizableHeader;
